import type { PreviewOrderQuoteOfferFeasibilityInput } from '@codezo/graphql';
import { useFeasibilityPreview } from '../../hooks/useFeasibilityPreview';
import { FeasibilityFeedback } from '../ui/feasibility-badge';

/**
 * The production-only feasibility floor for one tier.
 *
 * Production alone, deliberately — if making it misses the deadline no delivery
 * can rescue it, so this is answerable before any shipping method is chosen.
 * Shared by the pricing modal and the wizard so both price a tier identically.
 */
export function TierFeasibility({
	minDays,
	maxDays,
	deadline,
	acceptDeadline,
}: {
	minDays: string;
	maxDays: string;
	deadline?: string | null;
	acceptDeadline?: string | null;
}) {
	const minProductionDays = minDays ? parseInt(minDays, 10) : null;
	const maxProductionDays = maxDays ? parseInt(maxDays, 10) : null;
	const productionReady = minProductionDays != null && maxProductionDays != null;

	const input: PreviewOrderQuoteOfferFeasibilityInput | null = productionReady
		? {
				minProductionDays,
				maxProductionDays,
				deadline: deadline ?? undefined,
				acceptDeadline: acceptDeadline ?? undefined,
			}
		: null;
	const { production } = useFeasibilityPreview(input);

	if (!productionReady || !production) return null;
	return (
		<FeasibilityFeedback
			kind="production"
			verdict={production.verdict}
			projected={production.projectedCompletion}
			breakdown={production.breakdown}
			deadline={deadline}
		/>
	);
}
